import walkieTalkieImage from "../assets/images/walkie-talkie.webp";
import { useTalkieWalkie } from "../hooks/use-talkie-walkie";
import Header from "./Header";
import loadingImage from "../assets/images/loading.png";
import { useEffect } from "react";
import RadioConnect from "./RadioConnect";
import Navigation from "./Navigation";
import WalkieTalkieMenu from "./Menu/WalkieTalkieMenu";
import WalkieTalkieSettings from "./Settings/WalkieTalkieSettings";
import Players from "./Players/Players";
import Logs from "./Logs/Logs";
import { motion, AnimatePresence } from "framer-motion";

interface Props {
  className?: string;
}

export type ScreenType =
  | "radio-connect"
  | "menu"
  | "logs"
  | "settings"
  | "players";

const WalkieTalkie = ({ className = "" }: Props) => {
  const { activeScreen, setActiveScreen } = useTalkieWalkie<ScreenType>();

  // For developer: Here you can get saved channel and load home screen automatically
  useEffect(() => {}, []);

  const renderScreen = () => {
    switch (activeScreen) {
      case "radio-connect":
        return <RadioConnect />;
      case "logs":
        return <Logs />;
      case "menu":
        return <WalkieTalkieMenu />;
      case "players":
        return <Players />;
      case "settings":
        return <WalkieTalkieSettings />;
      default:
        return (
          <div className="flex items-center justify-center h-full rounded-b-xl">
            <div className="animate-spin">
              <img src={loadingImage} className="w-[30px] h-[30px]" alt="" />
            </div>
          </div>
        );
    }
  };

  return (
    <AnimatePresence>
      <motion.div
        className={className}
        initial={{ opacity: 0, y: 100 }} // starts lower
        animate={{ opacity: 1, y: 0 }} // slides up into place
        exit={{ opacity: 0, y: 100 }} // slides back down
        transition={{ duration: 0.5, ease: "easeOut" }}
      >
        <div className={`w-[340px] h-[800px] `}>
          <img
            src={walkieTalkieImage}
            alt="Walkie Talkie"
            loading="eager"
            className="w-full h-full"
          />

          {/** Screen in walkie talkie */}
          <main className="bg-gradient-to-b from-[#45455f] to-[#161820] absolute top-[385px] bottom-[56px] left-[40px] right-[45px] rounded-xl flex flex-col">
            <Header
              title="Walkie Talkie FM"
              batteryPercentage={70}
              className="rounded-t-xl"
            />

            <div className="px-4 py-3 overflow-y-hidden h-full">
              <Navigation
                onBackClick={() => {}}
                onFirstButtonClick={() => {
                  if (activeScreen !== "radio-connect") setActiveScreen("menu");
                }}
              />
              {renderScreen()}
            </div>
          </main>
        </div>
      </motion.div>
    </AnimatePresence>
  );
};

export default WalkieTalkie;
